if ( typeof HoculusColorSwatch !== 'function' ) {

    class HoculusColorSwatch extends HTMLElement {
        constructor() {
            super();

            this.config = JSON.parse(this.dataset.config);

            if (this.config.articleCode) {
                this.init();    
            }
        }

        async init() {
            const swatchMarkup = await this.getSwatchMarkup();
            
            if (swatchMarkup) {
                const dom = new DOMParser().parseFromString(swatchMarkup, 'text/html');
                const html = dom.querySelector('.shopify-section').innerHTML.trim();

                if (html) {
                    this.querySelector('.hoculus-color-swatch').innerHTML = html;
                    document.getElementById(`swatch-${this.config.productId}`).classList.add('active');
                } else {
                    this.remove();
                }
            }
        }

        async getSwatchMarkup() {
            try {

                const response = await fetch(`${window.Shopify.routes.root}collections/all?filter.p.m.hoculus.article-code=${this.config.articleCode}&section_id=hoculus-products-by-article-code`);

                const markup = await response.text();

                return markup;

            } catch (err) {
                console.log(err);
                return '';
            }
        }
    }

    if ( !customElements.get('hoculus-color-swatch') ) {
        customElements.define('hoculus-color-swatch', HoculusColorSwatch);
    }

}